<template>
  <div class="content">
    <div class="ttile">
      客服
      <span>
        说明：默认悬浮展示在页面
      </span>
    </div>

    <div class="set-item">
      <p class="title">样式基础设置</p>
      <SpRadio
        v-model="curComponent.canDrop"
        size="big"
        label="是否可拖动"
        :options="canDropOptions"
      />
      <SpSlider v-model="curComponent.margin" label="左右边距" />
    </div>

    <div class="upload_content">
      <span>图片</span>
      <UploadImg v-model="curComponent.url" />
    </div>

    <div class="phone_content">
      <p><span>*</span>联系电话</p>
      <div>
        <el-autocomplete
          popper-class="phone-autocomplete-popup"
          v-model="curComponent.phone"
          :fetch-suggestions="querySearch"
          placeholder="请输入联系电话"
        >
          <template slot-scope="{ item }">
            <div>{{ item.label }}</div>
          </template>
        </el-autocomplete>
        <p
          v-if="!curComponent.phone"
          style="font-size: 12px;color: red;padding-top: 10px;"
        >
          请填写联系电话
        </p>
        <p
          v-if="curComponent.phone && !verifyMobie(curComponent.phone)"
          style="font-size: 12px;color: red;padding-top: 10px;"
        >
          请输入正确的联系电话
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import SpRadio from "../../../components/SpRadio";
import SpSlider from "../../../components/SpSlider";

import UploadImg from "./components/UploadImg";
import { canDropOptions } from "./options";
import { getStoreList } from "@/api/shop/activitySet";

import { Decrtpt } from "@/utils/crypto.js";
export default {
  inject: ["control"],
  components: {
    SpRadio,
    SpSlider,
    UploadImg
  },
  computed: {
    curComponent() {
      return this.control.curComponent;
    }
  },
  data() {
    return {
      phoneOptions: [],
      canDropOptions: Object.freeze(canDropOptions)
    };
  },
  created() {
    this.getStoreList();
  },
  methods: {
    verifyMobie(phone) {
      const mobilePattern = /^1[3-9]\d{9}/;
      const landlinePattern = /^0\d{2,3}-?\d{7,8}$/;

      if (mobilePattern.test(phone) || landlinePattern.test(phone)) {
        return true;
      }
      return false;
    },
    querySearch(queryString, cb) {
      var restaurants = this.phoneOptions;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    getStoreList() {
      getStoreList().then(res => {
        this.phoneOptions = res.data.rows.map(item => {
          const value = Decrtpt(item.telephone);
          return {
            label: `${item.storeName} - ${value}`,
            value
          };
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  min-height: 885px;
  .ttile {
    padding: 22px 24px 20px 24px;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    font-weight: 500;
    span {
      font-size: 10px;
      color: #999999;
      margin-top: 4px;
    }
  }

  > .set-item {
    padding: 30px 24px 0px 24px;
    > .title {
      margin-bottom: 20px;
    }
    /deep/ .sp-radio {
      margin-bottom: 20px;
    }
  }

  > .upload_content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    margin-top: 20px;
    > span {
      font-size: 12px;
      color: #999999;
      font-weight: 400;
    }
  }
  > .phone_content {
    display: flex;
    padding: 20px 34px 0 24px;
    > p {
      font-size: 12px;
      margin-right: 23px;
      color: #999999;
      line-height: 32px;
      > span {
        color: red;
      }
    }
    > div {
      flex: 1;
      /deep/ .el-autocomplete {
        width: 100%;
        .el-input {
          .el-input__inner {
            height: 32px;
            line-height: 32px;
            background: #ffffff;
            border-radius: 2px;
            border: 1px solid #eeeeee;
            padding: 0 8px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/MobileAppoint/Attr.vue